import './delay_render_chart_view.js.coffee';# Added by Script 
import './timeline_chart_view.js.coffee'
Namespace 'CustomerVisualMode.Charts'

class CustomerVisualMode.Charts.BotAverageInteractionTimeChartView extends CustomerVisualMode.Charts.DelayRenderChartView
  className: 'grid-item full-width-chart bot_average_interaction_time'
  @NAME: 'bot_average_interaction_time'

  initialize: ({widget, data, session, isReadOnly, isResponsive}) ->
    title = I18n.t('customer_visual_mode.charts.bot_average_interaction_time.title')
    description = I18n.t('customer_visual_mode.charts.bot_average_interaction_time.description')
    times = data.map((value) -> value.time)
    series = @_createSeries(data)
    @timelineChart = new CustomerVisualMode.Charts.TimelineChartView({times, series})
    @listenTo(@timelineChart, 'timeline:click:line', @_openDrilldown)
    @dateRangeBuilder = new Common.Dashboard.Filters.DateRangeBuilder(session)
    super({widget, title, description, data, session, isReadOnly, isResponsive})

  render: ->
    super()
    @$el.find('.chart').append(@timelineChart.render().el)
    @

  _renderChart: ->
    @chart = @timelineChart.renderChart()

  _createSeries: (data) ->
    [
      {
        name: I18n.t('customer_visual_mode.charts.bot_average_interaction_time.average_time'),
        data: data.map((value) -> {y: value.count, time: value.time})
      }
    ]

  _openDrilldown: (drilldownValue, timeInSeconds) ->
    super({
      date: @dateRangeBuilder.build(timeInSeconds),
      dimensions: ['metrics', 'date'],
      name: 'Avg interactions bot',
      metric_names: ['human_and_bot_interaction'],
      drilldown_code: 'ticket_with_metrics',
      timezone: moment().format('Z')
    })
